import React from "react";
import BootcampSlide from "./BootcampSlide";
import { bootcamps } from '../content/collections/partnerbootcamps';

const PartnerBootcamps = () =>
    <BootcampSlide title="Boot camps" bootcamps={bootcamps} />

export default PartnerBootcamps;


// WEBPACK FOOTER //
// ./src/slides/PartnerBootcamps.js